export default __webpack_public_path__ + "static/media/star.f785281c.svg";